<template>
  <div class="scrollable-panel__wrapper" ref="panelCenter">
    <div class="scrollable-panel">
      <div class="scrollable-panel__left" :style="{ width: `${leftWidth}px` }">
        <div class="scrollable-panel__header">
          <slot name="left-panel-header"></slot>
        </div>
        <div>
          <slot name="left-panel-body"></slot>
        </div>
      </div>

      <div class="scrollable-panel__body">
        <div class="scrollable-panel__header">
          <slot name="center-panel-header"></slot>
        </div>
        <div>
          <slot name="center-panel-body"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick } from 'vue';

// ⭕️ 修正2: 親コンポーネントの指定に合わせて `startWidth` ➡️ `leftWidth` に変更
const props = withDefaults(defineProps<{
  initialScrollX?: number;
  leftWidth?: number; 
}>(), {
  initialScrollX: 0,
  leftWidth: 120
});

// ⭕️ 修正3: Vue 3における template ref (this.$refs の代わり) の取得方法
const panelCenter = ref<HTMLDivElement | null>(null);

onMounted(() => {
  const applyScroll = () => {
    const el = panelCenter.value;
    if (el) {
      el.scrollLeft = props.initialScrollX;
    }
  };
  applyScroll();
  if (props.initialScrollX !== 0) {
    nextTick(() => {
      setTimeout(applyScroll, 50);
    });
  }
});
</script>

<style lang="scss" scoped>
.scrollable-panel__wrapper {
  display: grid;
  overflow: auto;
  height: calc(100vh - 100px);
  width: 100%;
}

.scrollable-panel {
  display: flex;
  flex-wrap: nowrap;
}

.scrollable-panel__left {
  position: sticky;
  left: 0; /* ⭕️ 修正4: 'start: 0' は効かないため 'left: 0' に変更 */
  background: white;
  z-index: 3;
  border-right: solid 2px #c4c4c4;
}

.scrollable-panel__header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 2;
  border-bottom: solid 2px #c4c4c4;
}
</style>